import { Resort } from '@model/common';
import { useAsync } from 'react-use';
import { Tile } from './Tile';
import React from 'react';
import { getHero } from '@components/util';
import { TILE_IMAGES_FALLBACK } from '@mock/fallback';

export interface TileContainerProps {
  resort: Resort;
}
export const TileContainer = ({ resort }: TileContainerProps) => {
  const path: string = resort.path;
  const fallback = TILE_IMAGES_FALLBACK[0];

  const { value } = useAsync(async () => {
    return await getHero({ path, fallback });
  }, []);

  const image: string = value?.images && value?.images.length ? value?.images[0] : fallback;

  return <Tile resort={resort} image={image} />;
};
